import { render } from "./LobbyDisplay.vue?vue&type=template&id=47e06472&scoped=true"
import script from "./jsfiles/LobbyDisplay.js?vue&type=script&lang=js"
export * from "./jsfiles/LobbyDisplay.js?vue&type=script&lang=js"

import "./LobbyDisplay.vue?vue&type=style&index=0&id=47e06472&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e06472"]])

export default __exports__